module.exports = __webpack_public_path__ + "media/img/apple-icon-114x114-87a2927f6f20d827e5a3fde10eafb668.png";